// 📂 components/Client/Table/Menu/MenuTable.tsx
import React, { useEffect } from "react";
import MenuTableHeader from "./MenuTableHeader";
import MenuTableRow from "./MenuTableRow";
import { useMenu } from "../../../../hooks/menu/useMenu";
import { useModule } from "../../../../hooks/module/useModule";
import { useRole } from "../../../../hooks/useRole";
import { menuGridMinWidth } from "./menuTableGrid";

const MenuTable: React.FC = () => {
  const { menus, fetchMenusByModule } = useMenu();
  const { moduleDetail } = useModule();
  const { dropdownOptions } = useRole();

  useEffect(() => {
    if (moduleDetail?.id) {
      fetchMenusByModule(moduleDetail.id);
    }
  }, [moduleDetail?.id]);

  return (
    <div>
      <h4 className="mb-1 text-base font-semibold text-black dark:text-white">
        Configuración de menús
      </h4>
      <p className="mb-4 text-sm text-body dark:text-bodydark2">
        Define qué roles ven cada submenú y en qué orden aparecen.
      </p>

      {menus.length === 0 ? (
        <div className="py-4 text-sm text-body dark:text-bodydark2">
          No hay menús disponibles para este módulo.
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-stroke dark:border-strokedark">
          <div style={{ minWidth: menuGridMinWidth(dropdownOptions.length) }}>
            <MenuTableHeader />
            {menus.map((menu) => (
              <MenuTableRow key={menu.id} menu={menu} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuTable;
